import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import Avatar from "./basic-21-avatar.png";
import BgOption1 from "../images/bg-option-1.png";
import BgOption2 from "../images/bg-option-2.png";
import BgOption3 from "../images/bg-option-3.png";

import TemplateImage from "./template-image.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic21 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #21";
    this.id = "21";
    this.url = "/ai/carousels/basic-21";
    this.description = "Create a carousel of images";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Gerald Smith",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@iamgeraldsmith",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#EEF4FF",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },

        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#101828",
        },
        {
          label: "Secondry Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#444CE7",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Manrope",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "The Power of Data-Driven Marketing in B2B",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "56px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "700",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `The Power of Data-Driven Marketing in B2B`,
            max_words: 15,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value:
              "Discover how data-driven B2B marketing can elevate your strategy, delivering insights that shape impactful decisions.",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "700",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Delivering insights that shape impactful decisions.`,
            max_words: 15,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: "",
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Personalization Pays Off",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "700",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Personalize content using data insights to build stronger B2B relationships and trust.`,
            max_words: 15,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "ROI Boost",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "700",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Optimize resources, maximize ROI, and extend your B2B marketing budget through data-backed decisions.`,
            max_words: 15,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "What are your thoughts?",
            max_words: 3,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "700",
              },
            },
          },
          {
            label: "Sub CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Ready to transform your B2B marketing with data?",
            max_words: 3,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Follow for more!",
            max_words: 3,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getSecondaryColorVariant(common_settings) {
    return this.getSecondaryColor(common_settings) + "50";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Manrope";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center gap-10">
        <div className="w-[300px] flex flex-col items-center justify-center gap-5">
          {slide.elements[0]?.style ? (
            <MultilineView
              element={slide.elements[0]}
              getPropertyByStyleKey={(styleKey) =>
                this.getPropertyByStyleKey(styleKey, commonSettings)
              }
              getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
            />
          ) : (
            <TextView text={slide.elements[0]?.value} />
          )}

          {slide.elements[1]?.style ? (
            <MultilineView
              element={slide.elements[1]}
              getPropertyByStyleKey={(styleKey) =>
                this.getPropertyByStyleKey(styleKey, commonSettings)
              }
              getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
            />
          ) : (
            <TextView text={slide.elements[1]?.value} />
          )}

          {slide.elements[2]?.style ? (
            <MultilineView
              element={slide.elements[2]}
              getPropertyByStyleKey={(styleKey) =>
                this.getPropertyByStyleKey(styleKey, commonSettings)
              }
              getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
            />
          ) : (
            <TextView text={slide.elements[2]?.value} />
          )}
        </div>

        <div className="flex flex-col gap-3 items-center justify-center">
          <div
            className="rounded-full w-[64px] h-[64px] flex items-center justify-center"
            style={{
              backgroundColor: this.getSecondaryColor(commonSettings),
            }}
          >
            <img
              className="object-cover w-[58px] h-[58px] rounded-full"
              src={
                commonSettings.elements[1].value.image
                  ? commonSettings.elements[1].value.image
                  : LogoPlaceholder
              }
              style={{
                backgroundColor: this.getPrimaryColor(commonSettings),
              }}
              alt=""
            />
          </div>
          <div className="flex flex-col gap-1 items-center justify-center">
            <p
              className="text-[14px] leading-[20px] font-bold "
              style={{
                color: this.getPrimaryColor(commonSettings),
              }}
            >
              {commonSettings.elements[0].value}
            </p>
            <p
              className="text-[12px] font-medium leading-[18px] text-gray-600 "
              style={{
                color: this.getPrimaryColor(commonSettings),
              }}
            >
              {commonSettings.elements[2].value}
            </p>
          </div>
        </div>
      </div>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div className="absolute inset-x-0 top-[40px] px-[24px] flex flex-col items-center gap-[20px]">
        <div className="flex flex-col gap-3">
          <div className="leading-[38px]">
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>

          {slide.elements[1]?.style ? (
            <MultilineView
              element={slide.elements[1]}
              getPropertyByStyleKey={(styleKey) =>
                this.getPropertyByStyleKey(styleKey, commonSettings)
              }
              getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
            />
          ) : (
            <TextView text={slide.elements[1]?.value} />
          )}

          {slide.elements[2]?.value && (
            <img
              src={slide.elements[2].value}
              className="w-[352px] h-[180px] object-cover rounded-lg mt-4"
              alt=""
            />
          )}
        </div>
      </div>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div className="absolute inset-x-0 top-[68px] px-[24px] flex flex-col items-center gap-[20px]">
        <div className="flex flex-col gap-4">
          <div className="leading-[56px]">
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>

          {slide.elements[1]?.style ? (
            <MultilineView
              element={slide.elements[1]}
              getPropertyByStyleKey={(styleKey) =>
                this.getPropertyByStyleKey(styleKey, commonSettings)
              }
              getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
            />
          ) : (
            <TextView text={slide.elements[1]?.value} />
          )}
        </div>
      </div>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col items-center justify-center w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getPrimaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            ></div>
          )}
        </div>
        <div
          className="absolute top-0 left-0 w-[108px] h-[8px]"
          style={{
            backgroundColor: this.getSecondaryColor(commonSettings),
          }}
        ></div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}

        {index !== carouselLength - 1 && (
          <>
            <div className="absolute top-[428px] left-[24px] flex items-center gap-4">
              <div
                className="rounded-full w-[48px] h-[48px] flex items-center justify-center"
                style={{
                  backgroundColor: this.getSecondaryColor(commonSettings),
                }}
              >
                <img
                  className="object-cover w-[42px] h-[42px] rounded-full"
                  src={
                    commonSettings.elements[1].value.image
                      ? commonSettings.elements[1].value.image
                      : LogoPlaceholder
                  }
                  style={{
                    backgroundColor: this.getPrimaryColor(commonSettings),
                  }}
                  alt=""
                />
              </div>
              <div className="flex flex-col gap-0.5">
                <p
                  className="text-[16px] leading-[24px] font-bold "
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                  }}
                >
                  {commonSettings.elements[0].value}
                </p>
                <p
                  className="text-[14px] font-normal leading-[20px] text-gray-600 "
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                  }}
                >
                  {commonSettings.elements[2].value}
                </p>
              </div>
            </div>

            <svg
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="absolute top-[424px] left-[312px]"
            >
              <path
                d="M25.6403 15.7861C26.7548 15.7861 27.6584 14.8826 27.6584 13.768C27.6584 12.6534 26.7548 11.7499 25.6403 11.7499C24.5257 11.7499 23.6221 12.6534 23.6221 13.768C23.6221 14.8826 24.5257 15.7861 25.6403 15.7861Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M31.6335 21.9017C32.7481 21.9017 33.6516 20.9982 33.6516 19.8836C33.6516 18.7691 32.7481 17.8655 31.6335 17.8655C30.5189 17.8655 29.6154 18.7691 29.6154 19.8836C29.6154 20.9982 30.5189 21.9017 31.6335 21.9017Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M31.6335 15.7861C32.7481 15.7861 33.6516 14.8826 33.6516 13.768C33.6516 12.6534 32.7481 11.7499 31.6335 11.7499C30.5189 11.7499 29.6154 12.6534 29.6154 13.768C29.6154 14.8826 30.5189 15.7861 31.6335 15.7861Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M37.7492 21.9017C38.8638 21.9017 39.7673 20.9982 39.7673 19.8836C39.7673 18.7691 38.8638 17.8655 37.7492 17.8655C36.6346 17.8655 35.7311 18.7691 35.7311 19.8836C35.7311 20.9982 36.6346 21.9017 37.7492 21.9017Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M37.7492 27.8947C38.8638 27.8947 39.7673 26.9912 39.7673 25.8766C39.7673 24.762 38.8638 23.8585 37.7492 23.8585C36.6346 23.8585 35.7311 24.762 35.7311 25.8766C35.7311 26.9912 36.6346 27.8947 37.7492 27.8947Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M37.7492 15.7861C38.8638 15.7861 39.7673 14.8826 39.7673 13.768C39.7673 12.6534 38.8638 11.7499 37.7492 11.7499C36.6346 11.7499 35.7311 12.6534 35.7311 13.768C35.7311 14.8826 36.6346 15.7861 37.7492 15.7861Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M43.7424 21.9017C44.857 21.9017 45.7605 20.9982 45.7605 19.8836C45.7605 18.7691 44.857 17.8655 43.7424 17.8655C42.6279 17.8655 41.7243 18.7691 41.7243 19.8836C41.7243 20.9982 42.6279 21.9017 43.7424 21.9017Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M43.7424 27.8947C44.857 27.8947 45.7605 26.9912 45.7605 25.8766C45.7605 24.762 44.857 23.8585 43.7424 23.8585C42.6279 23.8585 41.7243 24.762 41.7243 25.8766C41.7243 26.9912 42.6279 27.8947 43.7424 27.8947Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M43.7424 15.7861C44.857 15.7861 45.7605 14.8826 45.7605 13.768C45.7605 12.6534 44.857 11.7499 43.7424 11.7499C42.6279 11.7499 41.7243 12.6534 41.7243 13.768C41.7243 14.8826 42.6279 15.7861 43.7424 15.7861Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M49.7357 21.9017C50.8502 21.9017 51.7538 20.9982 51.7538 19.8836C51.7538 18.7691 50.8502 17.8655 49.7357 17.8655C48.6211 17.8655 47.7175 18.7691 47.7175 19.8836C47.7175 20.9982 48.6211 21.9017 49.7357 21.9017Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M49.7357 27.8947C50.8502 27.8947 51.7538 26.9912 51.7538 25.8766C51.7538 24.762 50.8502 23.8585 49.7357 23.8585C48.6211 23.8585 47.7175 24.762 47.7175 25.8766C47.7175 26.9912 48.6211 27.8947 49.7357 27.8947Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M43.7424 33.888C44.857 33.888 45.7605 32.9844 45.7605 31.8699C45.7605 30.7553 44.857 29.8518 43.7424 29.8518C42.6279 29.8518 41.7243 30.7553 41.7243 31.8699C41.7243 32.9844 42.6279 33.888 43.7424 33.888Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M49.7357 33.888C50.8502 33.888 51.7538 32.9844 51.7538 31.8699C51.7538 30.7553 50.8502 29.8518 49.7357 29.8518C48.6211 29.8518 47.7175 30.7553 47.7175 31.8699C47.7175 32.9844 48.6211 33.888 49.7357 33.888Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M37.7492 40.0036C38.8638 40.0036 39.7674 39.1 39.7674 37.9853C39.7674 36.8707 38.8638 35.9671 37.7492 35.9671C36.6345 35.9671 35.7309 36.8707 35.7309 37.9853C35.7309 39.1 36.6345 40.0036 37.7492 40.0036Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M43.7424 40.0036C44.8571 40.0036 45.7607 39.1 45.7607 37.9853C45.7607 36.8707 44.8571 35.9671 43.7424 35.9671C42.6278 35.9671 41.7242 36.8707 41.7242 37.9853C41.7242 39.1 42.6278 40.0036 43.7424 40.0036Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M49.7356 40.0036C50.8503 40.0036 51.7539 39.1 51.7539 37.9853C51.7539 36.8707 50.8503 35.9671 49.7356 35.9671C48.621 35.9671 47.7174 36.8707 47.7174 37.9853C47.7174 39.1 48.621 40.0036 49.7356 40.0036Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M31.6335 46.0043C32.7481 46.0043 33.6516 45.1007 33.6516 43.9862C33.6516 42.8716 32.7481 41.9681 31.6335 41.9681C30.5189 41.9681 29.6154 42.8716 29.6154 43.9862C29.6154 45.1007 30.5189 46.0043 31.6335 46.0043Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M37.7492 46.0043C38.8638 46.0043 39.7673 45.1007 39.7673 43.9862C39.7673 42.8716 38.8638 41.9681 37.7492 41.9681C36.6346 41.9681 35.7311 42.8716 35.7311 43.9862C35.7311 45.1007 36.6346 46.0043 37.7492 46.0043Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M43.7424 46.0043C44.857 46.0043 45.7605 45.1007 45.7605 43.9862C45.7605 42.8716 44.857 41.9681 43.7424 41.9681C42.6279 41.9681 41.7243 42.8716 41.7243 43.9862C41.7243 45.1007 42.6279 46.0043 43.7424 46.0043Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M49.7357 46.0043C50.8502 46.0043 51.7538 45.1007 51.7538 43.9862C51.7538 42.8716 50.8502 41.9681 49.7357 41.9681C48.6211 41.9681 47.7175 42.8716 47.7175 43.9862C47.7175 45.1007 48.6211 46.0043 49.7357 46.0043Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M55.9812 27.8947C57.0958 27.8947 57.9993 26.9912 57.9993 25.8766C57.9993 24.762 57.0958 23.8585 55.9812 23.8585C54.8666 23.8585 53.9631 24.762 53.9631 25.8766C53.9631 26.9912 54.8666 27.8947 55.9812 27.8947Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M55.9812 33.888C57.0958 33.888 57.9993 32.9844 57.9993 31.8699C57.9993 30.7553 57.0958 29.8518 55.9812 29.8518C54.8666 29.8518 53.9631 30.7553 53.9631 31.8699C53.9631 32.9844 54.8666 33.888 55.9812 33.888Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M55.9812 40.0036C57.0958 40.0036 57.9994 39.1 57.9994 37.9853C57.9994 36.8707 57.0958 35.9671 55.9812 35.9671C54.8665 35.9671 53.9629 36.8707 53.9629 37.9853C53.9629 39.1 54.8665 40.0036 55.9812 40.0036Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M25.6403 52.2502C26.7549 52.2502 27.6585 51.3466 27.6585 50.232C27.6585 49.1174 26.7549 48.2137 25.6403 48.2137C24.5256 48.2137 23.622 49.1174 23.622 50.232C23.622 51.3466 24.5256 52.2502 25.6403 52.2502Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M31.6335 52.2502C32.7481 52.2502 33.6517 51.3466 33.6517 50.232C33.6517 49.1174 32.7481 48.2137 31.6335 48.2137C30.5188 48.2137 29.6152 49.1174 29.6152 50.232C29.6152 51.3466 30.5188 52.2502 31.6335 52.2502Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M37.7492 52.2502C38.8638 52.2502 39.7674 51.3466 39.7674 50.232C39.7674 49.1174 38.8638 48.2137 37.7492 48.2137C36.6345 48.2137 35.7309 49.1174 35.7309 50.232C35.7309 51.3466 36.6345 52.2502 37.7492 52.2502Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M43.7424 52.2502C44.8571 52.2502 45.7607 51.3466 45.7607 50.232C45.7607 49.1174 44.8571 48.2137 43.7424 48.2137C42.6278 48.2137 41.7242 49.1174 41.7242 50.232C41.7242 51.3466 42.6278 52.2502 43.7424 52.2502Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M61.9819 33.888C63.0965 33.888 64 32.9844 64 31.8699C64 30.7553 63.0965 29.8518 61.9819 29.8518C60.8673 29.8518 59.9638 30.7553 59.9638 31.8699C59.9638 32.9844 60.8673 33.888 61.9819 33.888Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
            </svg>
          </>
        )}
      </div>
    );
  }
}

export default Basic21;
